// ASCL language codes.
// This file is Used for identifying sppken languages and getting their ASCL codes.
// Also listing the languages available as per the AVETMISS standards in student onboarding flow
// https://www.ncver.edu.au/__data/assets/file/0025/7666/language_systemfile_2016.txt

export const languages = {
  'Non verbal': '0001',
  Swiss: '0003',
  Cypriot: '0004',
  'Creole, nfd': '0005',
  'French Creole, nfd': '0006',
  'Spanish Creole, nfd': '0007',
  'Portuguese Creole, nfd': '0008',
  'Pidgin, nfd': '0009',
  'NORTHERN EUROPEAN LANGUAGES': '1000',
  Celtic: '1100',
  'Gaelic (Scotland)': '1101',
  Irish: '1102',
  Welsh: '1103',
  'Celtic, nec': '1199',
  English: '1201',
  'German and Related Languages': '1300',
  German: '1301',
  Letzeburgish: '1302',
  Yiddish: '1303',
  'Dutch and Related Languages': '1400',
  Dutch: '1401',
  Frisian: '1402',
  Afrikaans: '1403',
  Scandinavian: '1500',
  Danish: '1501',
  Icelandic: '1502',
  Norwegian: '1503',
  Swedish: '1504',
  'Scandinavian, nec': '1599',
  'Finnish and Related Languages': '1600',
  Estonian: '1601',
  Finnish: '1602',
  'Finnish and Related Languages, nec': '1699',
  'SOUTHERN EUROPEAN LANGUAGES': '2000',
  French: '2101',
  Greek: '2201',
  'Iberian Romance': '2300',
  Catalan: '2301',
  Portuguese: '2302',
  Spanish: '2303',
  'Iberian Romance, nec': '2399',
  Italian: '2401',
  Maltese: '2501',
  'Other Southern European Languages': '2900',
  Basque: '2901',
  Latin: '2902',
  'Other Southern European Languages, nec': '2999',
  'EASTERN EUROPEAN LANGUAGES': '3000',
  Baltic: '3100',
  Latvian: '3101',
  Lithuanian: '3102',
  Hungarian: '3301',
  'East Slavic': '3400',
  Belorussian: '3401',
  Russian: '3402',
  Ukrainian: '3403',
  'South Slavic': '3500',
  Bosnian: '3501',
  Bulgarian: '3502',
  Croatian: '3503',
  Macedonian: '3504',
  Serbian: '3505',
  Slovene: '3506',
  'Serbo-Croatian/Yugoslavian': '3507',
  'West Slavic': '3600',
  Czech: '3601',
  Polish: '3602',
  Slovak: '3603',
  Czechoslovakian: '3604',
  'Other Eastern European Languages': '3900',
  Albanian: '3901',
  'Aromunian (Macedo-Romanian)': '3903',
  Romanian: '3904',
  Romany: '3905',
  'Other Eastern European Languages, nec': '3999',
  'SOUTHWEST AND CENTRAL ASIAN LANGUAGES': '4000',
  Iranic: '4100',
  Kurdish: '4101',
  Pashto: '4102',
  Balochi: '4104',
  Dari: '4105',
  Persian: '4106',
  Hazaraghi: '4107',
  'Iranic, nec': '4199',
  'Middle Eastern Semitic Languages': '4200',
  Arabic: '4202',
  Hebrew: '4204',
  'Assyrian Neo-Aramaic': '4206',
  'Chaldean Neo-Aramaic': '4207',
  'Mandaean (Mandaic)': '4208',
  'Middle Eastern Semitic Languages, nec': '4299',
  Turkic: '4300',
  Turkish: '4301',
  Azeri: '4302',
  Tatar: '4303',
  Turkmen: '4304',
  Uygur: '4305',
  Uzbek: '4306',
  'Turkic, nec': '4399',
  'Other Southwest and Central Asian Languages': '4900',
  Armenian: '4901',
  Georgian: '4902',
  'Other Southwest and Central Asian Languages, nec': '4999',
  'SOUTHERN ASIAN LANGUAGES': '5000',
  Dravidian: '5100',
  Kannada: '5101',
  Malayalam: '5102',
  Tamil: '5103',
  Telugu: '5104',
  Tulu: '5105',
  'Dravidian, nec': '5199',
  'Indo-Aryan': '5200',
  Bengali: '5201',
  Gujarati: '5202',
  Hindi: '5203',
  Konkani: '5204',
  Marathi: '5205',
  Nepali: '5206',
  Punjabi: '5207',
  Sindhi: '5208',
  Sinhalese: '5211',
  Urdu: '5212',
  Assamese: '5213',
  Dhivehi: '5214',
  Kashmiri: '5215',
  Oriya: '5216',
  'Fijian Hindustani': '5217',
  'Indo-Aryan, nec': '5299',
  'Other Southern Asian Languages': '5999',
  'SOUTHEAST ASIAN LANGUAGES': '6000',
  'Burmese and Related Languages': '6100',
  Burmese: '6101',
  'Chin Haka': '6102',
  Karen: '6103',
  Rohingya: '6104',
  Zomi: '6105',
  'Burmese and Related Languages, nec': '6199',
  'Hmong-Mien': '6200',
  Hmong: '6201',
  'Hmong-Mien, nec': '6299',
  'Mon-Khmer': '6300',
  Khmer: '6301',
  Vietnamese: '6302',
  Mon: '6303',
  'Mon-Khmer, nec': '6399',
  Tai: '6400',
  Lao: '6401',
  Thai: '6402',
  'Tai, nec': '6499',
  'Southeast Asian Austronesian Languages': '6500',
  Bisaya: '6501',
  Cebuano: '6502',
  IIokano: '6503',
  Indonesian: '6504',
  Malay: '6505',
  Tetum: '6507',
  Timorese: '6508',
  Tagalog: '6511',
  Filipino: '6512',
  Acehnese: '6513',
  Balinese: '6514',
  Bikol: '6515',
  Iban: '6516',
  'Ilonggo (Hiligaynon)': '6517',
  Javanese: '6518',
  Pampangan: '6521',
  'Southeast Asian Austronesian Languages, nec': '6599',
  'Other Southeast Asian Languages': '6999',
  'Eastern Asian Languages': '7000',
  Chinese: '7100',
  Cantonese: '7101',
  Hakka: '7102',
  Mandarin: '7104',
  Wu: '7106',
  'Min Nan': '7107',
  'Chinese, nec': '7199',
  Japanese: '7201',
  Korean: '7301',
  'Other Eastern Asian Languages': '7900',
  Tibetan: '7901',
  Mongolian: '7902',
  'Other Eastern Asian Languages, nec': '7999',
  'AUSTRALIAN INDIGENOUS LANGUAGES': '8000',
  'Arnhem Land and Daly River Region Languages': '8100',
  Anindilyakwa: '8101',
  Maung: '8111',
  "Ngan'gikurunggurr": '8113',
  Nunggubuyu: '8114',
  Rembarrnga: '8115',
  Tiwi: '8117',
  Alawa: '8121',
  Dalabon: '8122',
  Gudanji: '8123',
  Iwaidja: '8127',
  Jaminjung: '8128',
  Jawoyn: '8131',
  Jingulu: '8132',
  Kunbarlang: '8133',
  Larrakiya: '8136',
  'Malak Malak': '8137',
  Mangarrayi: '8138',
  Maringarr: '8141',
  Marra: '8142',
  Marrithiyel: '8143',
  Matngala: '8144',
  'Murrinh Patha': '8146',
  'Na-kara': '8147',
  'Ndjébbana (Gunavidji)': '8148',
  Ngalakgan: '8151',
  Ngaliwurru: '8152',
  Nungali: '8153',
  Wambaya: '8154',
  Wardaman: '8155',
  Amurdak: '8156',
  Garrwa: '8157',
  Kuwema: '8158',
  Marramaninyshi: '8161',
  Ngandi: '8162',
  Waanyi: '8163',
  Wagiman: '8164',
  Yanyuwa: '8165',
  'Marridan (Maridan)': '8166',
  Kunwinjkuan: '8170',
  Gundjeihmi: '8171',
  Kune: '8172',
  Kuninjku: '8173',
  Kunwinjku: '8174',
  Mayali: '8175',
  'Kunwinjkuan, nec': '8179',
  Burarran: '8180',
  Burarra: '8181',
  'Gun-nartpa': '8182',
  'Gurr-goni': '8183',
  'Burarran, nec': '8189',
  'Arnhem Land and Daly River Region Languages, nec': '8199',
  'Yolngu Matha': '8200',
  Dhangu: '8210',
  Galpu: '8211',
  Golumala: '8212',
  Wangurri: '8213',
  'Dhangu, nec': '8219',
  "Dhay'yi": '8220',
  Dhalwangu: '8221',
  Djarrwark: '8222',
  "Dhay'yi, nec": '8229',
  Dhuwal: '8230',
  Djambarrpuyngu: '8231',
  Djapu: '8232',
  Daatiwuy: '8233',
  Marrangu: '8234',
  Liyagalawumirr: '8235',
  Liyagawumirr: '8236',
  'Dhuwal, nec': '8239',
  Dhuwala: '8240',
  Gumatj: '8242',
  Gupapuyngu: '8243',
  Guyamirrilili: '8244',
  Manggalili: '8246',
  Wubulkarra: '8247',
  'Dhuwala, nec': '8249',
  Djinang: '8250',
  Wurlaki: '8251',
  'Djinang, nec': '8259',
  Ganalbingu: '8261',
  Djinba: '8262',
  Manyjalpingu: '8263',
  'Djinba, nec': '8269',
  Yakuy: '8270',
  Ritharrngu: '8271',
  Wagilak: '8272',
  'Yakuy, nec': '8279',
  Nhangu: '8281',
  'Yan-Nhangu': '8282',
  'Nhangu, nec': '8289',
  'Other Yolngu Matha': '8290',
  Dhuwaya: '8291',
  Djangu: '8292',
  Madarrpa: '8293',
  Warramiri: '8294',
  Rirratjingu: '8295',
  'Other Yolngu Matha, nec': '8299',
  'Cape York Peninsula Languages': '8300',
  'Kuku Yalanji': '8301',
  'Guugu Yimidhirr': '8302',
  "Kuuku-Ya'u": '8303',
  'Wik Mungkan': '8304',
  Djabugay: '8305',
  Dyirbal: '8306',
  Girramay: '8307',
  'Koko-Bera': '8308',
  'Kuuk Thayorre': '8311',
  Lamalama: '8312',
  Yidiny: '8313',
  'Wik Ngathan': '8314',
  Alngith: '8315',
  'Kugu Muminh': '8316',
  Morrobalama: '8317',
  Thaynakwith: '8318',
  Yupangathi: '8321',
  Tjungundji: '8322',
  'Cape York Peninsula Languages, nec': '8399',
  'Torres Strait Island Languages': '8400',
  'Kalaw Kawaw Ya/Kalaw Lagaw Ya': '8401',
  'Meriam Mir': '8402',
  'Yumplatok (Torres Strait Creole)': '8403',
  'Northern Desert Fringe Area Languages': '8500',
  Bilinarra: '8504',
  Gurindji: '8505',
  'Gurindji Kriol': '8506',
  Jaru: '8507',
  'Light Warlpiri': '8508',
  Malngin: '8511',
  Mudburra: '8512',
  Ngardi: '8514',
  Ngarinyman: '8515',
  Walmajarri: '8516',
  Wanyjirra: '8517',
  Warlmanpa: '8518',
  Warlpiri: '8521',
  Warumungu: '8522',
  'Northern Desert Fringe Area Languages, nec': '8599',
  Arandic: '8600',
  Alyawarr: '8603',
  Kaytetye: '8606',
  Antekerrepenh: '8607',
  Anmatyerr: '8610',
  'Central Anmatyerr': '8611',
  'Eastern Anmatyerr': '8612',
  'Anmatyerr, nec': '8619',
  Arrernte: '8620',
  'Eastern Arrernte': '8621',
  'Western Arrarnta': '8622',
  'Arrernte, nec': '8629',
  'Arandic, nec': '8699',
  'Western Desert Language': '8700',
  Antikarinya: '8703',
  Kartujarra: '8704',
  Kukatha: '8705',
  Kukatja: '8706',
  Luritja: '8707',
  Manyjilyjarra: '8708',
  'Martu Wangka': '8711',
  Ngaanyatjarra: '8712',
  Pintupi: '8713',
  Pitjantjatjara: '8714',
  Wangkajunga: '8715',
  Wangkatha: '8716',
  Warnman: '8717',
  Yankunytjatjara: '8718',
  Yulparija: '8721',
  Tjupany: '8722',
  'Western Desert Language, nec': '8799',
  'Kimberley Area Languages': '8800',
  Bardi: '8801',
  Bunuba: '8802',
  Gooniyandi: '8803',
  Miriwoong: '8804',
  Ngarinyin: '8805',
  Nyikina: '8806',
  Worla: '8807',
  Worrorra: '8808',
  Wunambal: '8811',
  Yawuru: '8812',
  Gambera: '8813',
  Jawi: '8814',
  Kija: '8815',
  'Kimberley Area Languages, nec': '8899',
  'Other Australian Indigenous Languages': '8900',
  Adnymathanha: '8901',
  Arabana: '8902',
  Bandjalang: '8903',
  Banyjima: '8904',
  Batjala: '8905',
  Bidjara: '8906',
  Dhanggatti: '8907',
  Diyari: '8908',
  Gamilaraay: '8911',
  Garuwali: '8913',
  Githabul: '8914',
  Gumbaynggir: '8915',
  Kanai: '8916',
  Karajarri: '8917',
  Kariyarra: '8918',
  Kaurna: '8921',
  Kayardild: '8922',
  Kriol: '8924',
  Lardil: '8925',
  Mangala: '8926',
  Muruwari: '8927',
  Narungga: '8928',
  Ngarluma: '8931',
  Ngarrindjeri: '8932',
  Nyamal: '8933',
  Nyangumarta: '8934',
  Nyungar: '8935',
  Paakantyi: '8936',
  'Palyku/Nyiyaparli': '8937',
  Wajarri: '8938',
  Wiradjuri: '8941',
  Yindjibarndi: '8943',
  Yinhawangka: '8944',
  'Yorta Yorta': '8945',
  Baanbay: '8946',
  Badimaya: '8947',
  Barababaraba: '8948',
  'Dadi Dadi': '8951',
  Dharawal: '8952',
  Djabwurrung: '8953',
  Gudjal: '8954',
  'Keerray-Woorroong': '8955',
  'Ladji Ladji': '8956',
  Mirning: '8957',
  Ngatjumaya: '8958',
  Waluwarra: '8961',
  Wangkangurru: '8962',
  Wargamay: '8963',
  Wergaia: '8964',
  Yugambeh: '8965',
  'Aboriginal English': '8998',
  'Other Australian Indigenous Languages, nec': '8999',
  'Other Languages': '9000',
  'American Languages': '9101',
  'African Languages': '9200',
  Acholi: '9201',
  Akan: '9203',
  'Mauritian Creole': '9205',
  Oromo: '9206',
  Shona: '9207',
  Somali: '9208',
  Swahili: '9211',
  Yoruba: '9212',
  Zulu: '9213',
  Amharic: '9214',
  Bemba: '9215',
  Dinka: '9216',
  Ewe: '9217',
  Ga: '9218',
  Harari: '9221',
  Hausa: '9222',
  Igbo: '9223',
  Kikuyu: '9224',
  Krio: '9225',
  Luganda: '9226',
  Luo: '9227',
  Ndebele: '9228',
  Nuer: '9231',
  'Nyanja (Chichewa)': '9232',
  Shilluk: '9233',
  Tigré: '9234',
  Tigrinya: '9235',
  Tswana: '9236',
  Xhosa: '9237',
  'Seychelles Creole': '9238',
  Anuak: '9241',
  Bari: '9242',
  Bassa: '9243',
  'Dan (Gio-Dan)': '9244',
  Fulfulde: '9245',
  'Kinyarwanda (Rwanda)': '9246',
  'Kirundi (Rundi)': '9247',
  Kpelle: '9248',
  Krahn: '9251',
  'Liberian (Liberian English)': '9252',
  'Loma (Lorma)': '9253',
  'Lumun (Kuku Lumun)': '9254',
  Madi: '9255',
  Mandinka: '9256',
  Mann: '9257',
  'Moro (Nuba Moro)': '9258',
  Themne: '9261',
  Lingala: '9262',
  'African Languages, nec': '9299',
  'Pacific Austronesian Languages': '9300',
  Fijian: '9301',
  Gilbertese: '9302',
  'Maori (Cook Island)': '9303',
  'Maori (New Zealand)': '9304',
  Nauruan: '9306',
  Niue: '9307',
  Samoan: '9308',
  Tongan: '9311',
  Rotuman: '9312',
  Tokelauan: '9313',
  Tuvaluan: '9314',
  Yapese: '9315',
  'Pacific Austronesian Languages, nec': '9399',
  'Oceanian Pidgins and Creoles': '9400',
  Bislama: '9402',
  'Hawaiian English': '9403',
  "Norf'k-Pitcairn": '9404',
  'Solomon Islands Pijin': '9405',
  'Oceanian Pidgins and Creoles, nec': '9499',
  'Papua New Guinea Languages': '9500',
  Kiwai: '9502',
  'Motu (HiriMotu)': '9503',
  'Tok Pisin (Neomelanesian)': '9504',
  'Papua New Guinea Languages, nec': '9599',
  'Invented Languages': '9601',
  'Sign Languages': '9700',
  Auslan: '9701',
  'Key Word Sign Australia': '9702',
  'Sign Languages, nec': '9799',
};
